export { default } from "./InternalToolingPanel";
